// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23Seq","content":"styles_content__2BJjZ","tableWrap":"styles_tableWrap__1PA2o"};